import ActionMenu from "../../../../../../components/actionMenu/ActionMenu";

import { useAppDispatch } from "../../../../../../redux/hooks";
import { CargoNodeDataInterface } from "../../../../../../redux/interfaces/raports.interface";
import {
  openFinishingDeliveryModal,
  setSelectedFinishingDeliveryData,
} from "../../../../../../redux/reducer/raports.reducer";

function CargoActionButton({
  crudData,
}: {
  itemId: string;
  crudData: CargoNodeDataInterface;
  tableContext: any;
}) {
  const dispatch = useAppDispatch();
  const finishDeliveryValidation = crudData.sn_bin !== null;

  const handleFinishDelivery = () => {
    if (!finishDeliveryValidation) return;
    dispatch(openFinishingDeliveryModal());
    dispatch(setSelectedFinishingDeliveryData(crudData));
  };
  return (
    <ActionMenu
      title={crudData.sn_bin ?? crudData.doc_trans ?? undefined}
      items={[
        {
          id: "finish-delivery",
          label: "Finalizeaza livrarea",
          icon: "DELIVERED_AWB",
          tooltip: finishDeliveryValidation
            ? "Deschide formularul pentru finalizarea livrarii acestui BIN."
            : "Finalizarea livrarii este disponibila doar pentru un BIN.",
          disabled: !finishDeliveryValidation,
          onClick: handleFinishDelivery,
        },
      ]}
    />
  );
}

export default CargoActionButton;
